import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { WalletState } from 'src/app/states/wallets.state';

@Component({
  selector: 'app-cartera-column-field',
  templateUrl: './cartera-column-field.component.html',
  styleUrls: ['./cartera-column-field.component.scss']
})
export class CarteraColumnFieldComponent implements OnInit, OnDestroy {

  @Input()
  id: number;

  @Input()
  field: string;

  @Input()
  class:  string;

  value: any;

  subscription: Subscription;

  constructor(private store: Store) { }

  ngOnInit(): void {

    this.subscription = this.store.select(WalletState.wallets).subscribe((cs: any[]) => {

      console.log('cs:',cs);

      const cartera = cs.find(c => c.id === this.id);
      if (!this.field || !cartera) {

        return;
      }

      let value = cartera[this.field];

      switch (this.field) {

        case 'cambioTotalPorc':
          const cambioTotal = cs.map(c => parseFloat(c.cambioTotal || 0))
              .reduce((sum, cambio) => sum + cambio, 0);
          value = (cambioTotal != 0 ? 100 * cartera.cambioTotal / cambioTotal : 0).toFixed(2);
          break;

        case 'cambioDiaPorc':
          const cambioDiario  = cs.map(c => parseFloat(c.cambioDia || 0))
              .reduce((sum, cambio) => sum + cambio, 0);
          value = (cambioDiario != 0 ? 100 * cartera.cambioDia / cambioDiario : 0).toFixed(2);
          break;
      }

      if (this.value !== value) {

        this.value = value;
      }
    });
  }

  ngOnDestroy(): void {

    this.subscription?.unsubscribe();
  }

}
